<nav>
  <ul class="flex flex-col justify-end gap-4 text-sm text-gray-500 sm:flex-row">
    @for (l of links$ | async; track $index) {
      <li class="hover:text-gray-400" [ngClass]="{ pleparation: !l.valid }">
        @if (l.innerLink) {
          <a routerLink="{{ l.link }}" (click)="close()">{{ l.text }}</a>
        } @else {
          <a href="{{ l.link }}" (click)="close()" target="_blank">{{ l.text }}</a>
        }
      </li>
    }
  </ul>
</nav>
